
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"stroke",attrs:{"d":"M16 16V14.5M16 16H7.73244M16 16H16.2676M16 9.00001V5.00001L3.00006 5C2.44778 5 2.00006 5.44771 2.00006 5.99999L2 16H4.26756M16 9.00001H19.5L22 12V13M16 9.00001V13M22 13H16M22 13V14.5M16 13V14.5M16 14.5H22M22 14.5V16H19.7324M7.73244 16C7.38663 15.4022 6.74028 15 6 15C5.25972 15 4.61337 15.4022 4.26756 16M7.73244 16C7.90261 16.2942 8 16.6357 8 17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17C4 16.6357 4.09739 16.2942 4.26756 16M16.2676 16C16.0974 16.2942 16 16.6357 16 17C16 18.1046 16.8954 19 18 19C19.1046 19 20 18.1046 20 17C20 16.6357 19.9026 16.2942 19.7324 16M16.2676 16C16.6134 15.4022 17.2597 15 18 15C18.7403 15 19.3866 15.4022 19.7324 16","stroke":"#30373D","stroke-width":"2"}})])
          )
        }
      }
    